<template>
  <v-card :color="ui.cardColor" dark :max-width="ui.cardMaxWidth" :max-height="ui.cardMaxHeight">
    <v-card-title>
      <v-icon large left :color="ui.iconColor"> analytics </v-icon>
      <span :class="ui.textHeadline"> Business </span>
    </v-card-title>

    <v-card-text class="ml-2">
      <div :class="ui.textDescription">
        Company strategy, budget, planning, orders, risks and actions tracking.
      </div>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow">
        <GetRegisterListPage :data="{tag: 'K6', tagd: 'B3', tags: 'B3', size: 'flat'}"
        v-if="this.licenceOK &&
        this.userOK &&
        this.getUser.pref.select.cauth !== null"/>
        <v-spacer/>
        <v-btn :color="ui.btnColor" flat dark :to="'/companydashbusiness'"
        v-if="this.licenceOK && this.userOK">
          <v-icon left>
            info
          </v-icon>
          Detail
        </v-btn>
        <v-btn :color="ui.colorWarning" flat dark
        v-if="!this.licenceOK || !this.userOK">
          <v-icon left>
            info
          </v-icon>
          Restricted Use
        </v-btn>
      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
import GetRegisterListPage from "@/data/register/components/GetRegisterListPage";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import { mapGetters } from "vuex";

export default {
  mixins: [apptheme, licenceFunctions, adminFunctions],
  components: {
    GetRegisterListPage
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters(["getUser"])
  },
  data() {
    return {
      valid: true
    };
  }
};
</script>
